module.exports = __webpack_public_path__ + "static/wpack/extracted/coco-logo096fdcccc777cae0ec6629f306c137c6.svg";